// Punto de entrada de la exportación de Reportes Recepción: elige la estructura según la vista
// (Resumen, Estadísticas del bot o Pro/Históricas) y deja solo las pestañas pedidas.
// exportacionPdf.js y ReportesExcel.js recorren lo que devuelve esto, sin saber de qué vista vino.
import { construirReporteRecepcion, filtrarPestanas } from './exportacionTablas';
import { construirReporteSimple } from './vistaSimple';

const VISTAS_RESUMEN = ['simple', 'bot'];

/**
 * @param {object} config datos de la pantalla; config.vista = 'simple' (Resumen) o 'bot'
 *        (Estadísticas del bot) usan la estructura del Resumen, cualquier otro valor la completa.
 *        config.seccionExportar filtra pestañas.
 */
export function construirReporteExportacion(config = {}) {
    const reporte = VISTAS_RESUMEN.includes(config.vista) ? construirReporteSimple(config) : construirReporteRecepcion(config);
    return { ...reporte, pestanas: filtrarPestanas(reporte, config.seccionExportar) };
}

export default construirReporteExportacion;
